import { useEffect, useState } from 'react';
import { airTracker } from '@/utils/airTracker';
import { getCountryData } from '@/api/countryAddress';

export const useCountryAddress = () => {
  const [loading, setLoading] = useState(true);
  const [country, setCountry] = useState<string>();

  useEffect(() => {
    const fetchCountryData = async (): Promise<void> => {
      setLoading(true);
      try {
        const data = await getCountryData();
        setCountry?.(data.countryCode);
        setLoading(false);
        airTracker.updateCommonData({ countryCode: data.countryCode });
      } catch (error) {
        airTracker.error('apiError', { api: 'getCountry', error });
        setLoading(false);
      }
    };
    fetchCountryData();
  }, []);

  return { country, loading };
};
